(ns iris.logs.views.eid
  (:require
   [re-frame.core :as re-frame]
   [iris.logs.views.post :refer [screening-badge]]
   [iris.posts.subs :as posts-subs]
   [shadow.css :refer [css]]))


(def ^:private eid-type-descriptions
  {"m:" "MIME Types (\"Accept\" browser header)"
   "l:" "Languages (\"Accept Language\" browser header)"
   "f:" "Fingerprint (BFP)"
   "c:" "Cookie"
   "d:" "Device Fingerprint (DFP)"
   "g:" "Geo-Location"
   "a:" "User Agent"})

(defn- format-seen [iso]
  (when iso (.toUTCString (js/Date. iso))))

(defn eid-btns [eid]
  (let [metadata @(re-frame/subscribe [::posts-subs/eid-metadata eid])
        timespan @(re-frame/subscribe [::posts-subs/eid-logs])
        ss       @(re-frame/subscribe [::posts-subs/screning-status eid])]
    [:div
     [:dl {:class "dl-horizontal"}
      [:dt "EID Type"]
      [:dd (get eid-type-descriptions (subs eid 0 2) "Unknown")]
      [:dt "Full EID"]
      [:dd {:style {:word-wrap "break-word"}} [:code eid]]
      [:dt "Original ruid"]
      [:dd [:code (:orig_ruid metadata)]]]
     [:div {:class (css "btn-group" :mb-3)}
      [:button {:class "btn btn-default" :disabled true} "Logs:"]
      [:button {:class "btn btn-default" :disabled true}
       [:em "First seen: "]
       [:strong (or (format-seen (:first_seen timespan)) "—")]]
      [:button {:class "btn btn-default" :disabled true}
       [:em "Last seen: "]
       [:strong (or (format-seen (:last_seen timespan)) "—")]]]
     [:div
      [:a {:href  (str "/posts?eid=" eid)
           :class "btn btn-primary"}
       [:i {:class "glyphicon glyphicon-align-justify"}]
       " All posts"]
      [:div.screening-badge-wrap
       [screening-badge ss eid]]]]))
